import React, { useState, useEffect } from "react";
import { LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import { HiOutlineArrowRight } from "react-icons/hi";
import Table from "../../common/Table";
import Loader from "../../common/Loader";
import Button from "../../common/Button";
import { DiePurchaseOrderAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import { formatDate } from "../../utlis/formateDate";
import DieInwardModal from "./DieInwardModal";

const PendingInwardTab = () => {
    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const [isInwardModalOpen, setIsInwardModalOpen] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await DiePurchaseOrderAPI.getPendingInwardItems();
            if (res?.success) {
                setDataList(res.data || []);
            }
        } catch (error) {
            notify("Error fetching pending items", "error");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleInwardProcess = () => {
        if (selectedItems.length === 0) {
            notify("Please select at least one die to inward", "warning");
            return;
        }
        setIsInwardModalOpen(true);
    };

    const handleInwardSuccess = () => {
        setIsInwardModalOpen(false);
        setSelectedItems([]);
        fetchData();
    };

    const columns = [
        { key: "pO_No", label: "PO #" },
        { key: "pO_Date", label: "PO Date", render: (val) => formatDate(val) },
        { key: "supplier_Name", label: "Supplier" },
        { key: "dieNumber", label: "Die Number" },
        { key: "subDieNo", label: "Sub Die#" },
        { key: "profile_Name", label: "Profile Name" },
        { key: "series_Name", label: "Series" },
        { key: "width_Height", label: "W * H" },
        { key: "orderWeight", label: "Order Wt" },
    ];

    const filteredData = dataList.filter(item => 
        !searchTerm || 
        item.dieNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.pO_No?.toString().includes(searchTerm) ||
        item.supplier_Name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="flex flex-col h-full animate-in fade-in duration-500">
            {/* Header / Actions */}
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-4 bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                <div className="flex flex-col">
                    <h3 className="text-xl font-bold text-blue-900">Pending Die Receipts</h3>
                    <p className="text-sm text-blue-600 font-medium">Select dies that have arrived to update inventory</p>
                </div>

                <div className="flex items-center gap-3 w-full sm:w-auto">
                    <div className="relative w-full sm:w-64 group">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <LiaSearchSolid className="h-5 w-5 text-slate-400 group-focus-within:text-blue-500 transition-colors" />
                        </div>
                        <input
                            type="text"
                            placeholder="Find Die or PO..."
                            className="block w-full pl-10 pr-8 py-2.5 bg-white border border-slate-200 text-slate-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 transition-all outline-none"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                            <button onClick={() => setSearchTerm("")} className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-red-500">
                                <MdClose size={16} />
                            </button>
                        )}
                    </div>

                    <Button
                        text={`Inward Selected (${selectedItems.length})`}
                        className={`${selectedItems.length > 0 ? "bg-blue-600 text-white shadow-blue-200 hover:bg-blue-700" : "bg-slate-200 text-slate-400 cursor-not-allowed"} font-bold px-5 py-2.5 rounded-lg flex items-center shadow-lg transition-all active:scale-95 whitespace-nowrap text-sm`}
                        icon={HiOutlineArrowRight}
                        onClick={handleInwardProcess}
                        disabled={selectedItems.length === 0}
                    />
                </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-auto rounded-xl border border-slate-100 bg-white shadow-sm">
                {loading ? (
                    <div className="h-64 flex items-center justify-center"><Loader /></div>
                ) : (
                    <Table
                        columns={columns}
                        data={filteredData}
                        showActions={false}
                        checkbox={{
                            idField: "trn_No",
                            selected: selectedItems,
                            onToggle: (id, checked) => {
                                if (checked) {
                                    setSelectedItems(prev => [...prev, id]);
                                } else {
                                    setSelectedItems(prev => prev.filter(x => x !== id));
                                }
                            },
                            onToggleAll: (ids, checked) => {
                                if (checked) {
                                    setSelectedItems(ids);
                                } else {
                                    setSelectedItems([]);
                                }
                            }
                        }}
                        rowIdField="trn_No"
                        tableClassName="text-[13px] font-medium"
                    />
                )}
            </div>

            {isInwardModalOpen && (
                <DieInwardModal
                    selectedItems={dataList.filter(item => selectedItems.includes(item.trn_No))}
                    onClose={() => setIsInwardModalOpen(false)}
                    onSuccess={handleInwardSuccess}
                />
            )}
        </div>
    );
};

export default PendingInwardTab;
